export default "__VITE_ASSET__CBFdD6ex__"